import { BaseConnector } from './baseConnector';

class HearingRoleConnector extends BaseConnector {
  getHearingRoles() {
    var url = `${this.baseApiUrl}/hearingRole`;
    return this.authFetch(url);
  }
}

export { HearingRoleConnector };
